import {objectFromEntries} from '@benchling/js-utils';

import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PIPELINE_STEP_SHAPES} from 'pipelines/GeneratedPipelineStepShapes';
import {StepConfigShape} from 'pipelines/StepShapeUtils';
import {JSONValue} from 'util/Types';

import {STEP_CONFIG_SETTINGS_V2} from '../step-config-settings/StepConfigSettings';
import {ShapeUISchemaV2, getFieldSettingsIfPresentV2} from '../StepConfigEditorTypes';
import {stepTypeIsConfigEditorSupported} from '../stepTypeIsConfigEditorSupported';
import jsonSpecToInitialValue from './jsonSpecToInitialValue';

export function makeInitialConfigStateFromConfigShape(
  configShape: StepConfigShape,
  uiSchema: ShapeUISchemaV2
): Record<string, JSONValue> {
  return objectFromEntries(
    Object.entries(configShape).map(([variableName, jsonSpec]) => [
      variableName,
      jsonSpecToInitialValue(jsonSpec, getFieldSettingsIfPresentV2(uiSchema, variableName)),
    ])
  );
}

export default function makeInitialConfigState(
  stepType: PipelineStepType,
  stepVersion: number
): Record<string, JSONValue> {
  assert(
    stepTypeIsConfigEditorSupported(stepType, stepVersion) && stepType !== PipelineStepType.CHART_VIEW,
    `Unexpected ${stepType} v${stepVersion}`
  );
  const configVariablesShape = PIPELINE_STEP_SHAPES[stepType][stepVersion].config as StepConfigShape;

  const uiSchema: ShapeUISchemaV2 | undefined = STEP_CONFIG_SETTINGS_V2[stepType][stepVersion]
    ?.uiSchema as ShapeUISchemaV2;
  return makeInitialConfigStateFromConfigShape(configVariablesShape, uiSchema);
}
